export enum SessionStorageKey {
  OTP_LOGGING_IN_EMAIL = 'otp_logging_in_email',
  OTP_LOGGING_IN_PASSWORD = 'otp_logging_in_password',
  OTP_LOGGING_IN_REMEMBER_ME = 'otp_logging_in_remember_me',
  ACCOUNT_ACTIVATE_EMAIL = 'account_activate_email',
  POST_LOGIN_REDIRECT = 'post_login_redirect',
  HAS_CUSTOM_LOGIN_REDIRECT = 'has_custom_login_redirect',
  CONTAINER_TAB_ID = 'container_tab_id'
}
